/**
 * @voltxampere/ui — Solder bond shimmer (Sprint 58b)
 *
 * 5th of 5 VISION §6.E P1 polish effects. Stamps a metallic
 * radial-gradient blob + occasional sparkle at every wire ↔
 * component joint. Pure draw helper — caller owns timing,
 * concurrent-cap bookkeeping, and viewport culling.
 *
 * Sparkle rendering is opt-in (`opts.sparkle` boolean); the metallic
 * base is always drawn. The base radius is small (~3 px) so the
 * effect reads as a tactile pin halo rather than a glowy blob.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export const DEFAULT_BASE_RADIUS_PX = 3;
export const SPARKLE_DURATION_MS = 320;
export function drawSolderShimmer(ctx, opts, theme) {
    const { point } = opts;
    const radius = opts.baseRadiusPx ?? DEFAULT_BASE_RADIUS_PX;
    ctx.save();
    // Metallic base — radial gradient from highlight to brass-dim.
    if (typeof ctx.createRadialGradient === "function") {
        const grad = ctx.createRadialGradient(point.x - radius * 0.25, point.y - radius * 0.25, 0, point.x, point.y, radius);
        grad.addColorStop(0, "#FFFFFF");
        grad.addColorStop(0.45, theme.accent.brassHot);
        grad.addColorStop(1, theme.accent.brassDim);
        ctx.fillStyle = grad;
    }
    else {
        ctx.fillStyle = theme.accent.brass;
    }
    ctx.beginPath();
    ctx.arc(point.x, point.y, radius, 0, Math.PI * 2);
    ctx.fill();
    // Sparkle overlay — small bright dot that grows + fades.
    if (opts.sparkle === true) {
        const progress = Math.max(0, Math.min(1, opts.sparkleProgress ?? 0));
        // 0..1 maps to a single grow-and-shrink curve via sin.
        const intensity = Math.sin(progress * Math.PI);
        const sparkleRadius = radius * (1.2 + intensity * 1.4);
        ctx.fillStyle = "#FFFFFF";
        ctx.globalAlpha = intensity * 0.95;
        ctx.beginPath();
        ctx.arc(point.x, point.y, sparkleRadius, 0, Math.PI * 2);
        ctx.fill();
    }
    ctx.restore();
}
//# sourceMappingURL=solder-shimmer.js.map